/**
 * What the search help says (#2290): every filter with an example, and
 * complete example searches. Each example must parse with no problem (a test
 * checks); a name in one is looked up when it is run.
 */
import type { TokenKind } from './searchSyntax';

interface FilterHelp {
  example: string;
  kind: TokenKind;
  what: string;
}

export const FILTER_HELP: FilterHelp[] = [
  { example: 'tag:port-ops', kind: 'tag', what: 'Has this tag. Several tag: filters: has all of them.' },
  { example: 'tag:ais|vessel', kind: 'tag', what: 'Has any of these tags (one either-or group per search).' },
  { example: '-tag:draft', kind: 'exclude', what: 'Does not have this tag.' },
  { example: 'author:me', kind: 'author', what: 'Owned by you. author:"Jane Doe" names a person; several: by any of them.' },
  { example: 'updated:30d', kind: 'date', what: 'Updated in the last 7d, 30d, 90d or 1y.' },
  { example: 'created:>=2026-01-01', kind: 'date', what: 'Created on or after a day. Also >, <=, <, one day, or a range 2026-01-01..2026-03-31.' },
  { example: 'is:pick', kind: 'flag', what: "Editor's picks only." },
  { example: 'is:shared', kind: 'shared', what: 'Shared with you by someone else.' },
  { example: 'group:"Port Ops"', kind: 'shared', what: 'Shared with a group.' },
  { example: 'uses:"Geo Buffer"', kind: 'uses', what: 'Uses this functional. Several uses: filters: uses all of them.' },
  { example: 'uses:"Geo Buffer"+Lookup|Join', kind: 'uses', what: 'Uses (Geo Buffer and Lookup) or Join: + is and, | is or, and + binds tighter. At most 5 alternatives of 10.' },
  { example: 'uses:Clip uses:"Geo Buffer"|Join', kind: 'uses', what: 'Several uses: filters must all hold: Clip and (Geo Buffer or Join), that is (Clip and Geo Buffer) or (Clip and Join).' },
  { example: 'submodel:"Port Calls"', kind: 'submodel', what: 'Uses this model inside it, with + and | as for uses:.' },
  { example: 'sort:updated', kind: 'sort', what: 'Order: relevance, updated, created, name or runs (most run this week).' },
];

export const HELP_EXAMPLES: { query: string; what: string }[] = [
  { query: 'berth tag:port-ops updated:30d', what: '"berth" in port-ops models changed this month' },
  { query: 'author:me -tag:draft sort:updated', what: 'Your models that are not drafts, newest change first' },
  { query: 'is:pick tag:ais|vessel', what: "Editor's picks tagged ais or vessel" },
  { query: 'created:>=2026-01-01 sort:runs', what: 'Models made this year, most run this week first' },
  { query: 'is:shared sort:name', what: 'Everything shared with you, A to Z' },
  { query: 'uses:"Geo Buffer"+Lookup|Join', what: 'Models that use Geo Buffer and Lookup, or Join' },
];
